import './index.scss'

import React from 'react'
import { CookiesProvider } from 'react-cookie'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'

import { Routes } from './routes/Routes'
import * as serviceWorker from './serviceWorker'
import { setupAxios } from './util/http-client'
import { App } from './app'

setupAxios()

ReactDOM.render(
  <React.StrictMode>
    <img alt="Logo" src="watermark-logo.svg" className="fixed-logo" />
    <CookiesProvider>
      <App>
        <Router>
          <main className="main-container">
            <Routes />
          </main>
        </Router>
      </App>
    </CookiesProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
